<template>
  <base-modal ref="modal" size="5xl" @hiding="$refs.video && $refs.video.pause()">
    <base-card class="tw-overlow-auto tw-relative" no-padding>
      <div v-if="isLoading" class="tw-flex tw-justify-center tw-items-center tw-h-screen">
        <base-spinner dark />
      </div>
      <div class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6">
        <div v-if="document.extension === 'pdf'">
          <pdf :src="documentSrc" @error="() => {}" @num-pages="pdfNumPages = $event" @page-loaded="pdfCurrentPage = $event" :page="pdfCurrentPage" />
        </div>
        <div id="container" class="tw-overflow-auto" v-if="document.extension === 'docx'"></div>
        <img :src="documentSrc" v-if="document.extension === 'png' || document.extension === 'jpeg' || document.extension === 'jpg'" class="tw-w-full" />
        <video :src="documentSrc" controls v-if="['mp4', 'm4v'].includes(document.extension)" class="tw-w-full" ref="video">
          <source :src="documentSrc" :type="`video/${document.extension}`" />
        </video>
      </div>
      <div class="tw-flex tw-justify-between tw-items-center tw-mt-2 tw-sticky tw-bottom-0 tw-inset-x-0 tw-bg-white tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6 tw-rounded-b">
        <div>
          <div v-if="document.extension === 'pdf'" class="tw-space-x-3 tw-flex tw-items-center">
            <base-icon :color="pdfCurrentPage > 1 ? 'primary' : 'gray'" @click="pdfCurrentPage > 1 && pdfCurrentPage--">
              <chevron-left-icon class="tw-w-5 tw-h-5" />
            </base-icon>
            <base-icon :color="pdfCurrentPage < pdfNumPages ? 'primary' : 'gray'" @click="pdfCurrentPage < pdfNumPages && pdfCurrentPage++">
              <chevron-right-icon class="tw-w-5 tw-h-5" />
            </base-icon>
            <div class="tw-text-gray-600" v-if="pdfNumPages">{{ pdfCurrentPage }} / {{ pdfNumPages }}</div>
          </div>
        </div>
        <base-button type="flat" @click="hide">Close</base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from "../assets/svgs";
import pdf from "vue-pdf";
const docx = require("docx-preview");

export default {
  components: {
    pdf,
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  data() {
    return {
      isLoading: false,
      document: {},
      documentSrc: "",
      pdfNumPages: 0,
      pdfCurrentPage: 1,
    };
  },
  methods: {
    show(document) {
      this.$refs.modal.show();
      this.document = document;
    },
    hide() {
      this.$refs.modal.hide();
    },
    async getDocument() {
      try {
        this.isLoading = true;
        this.documentSrc = null;
        this.pdfCurrentPage = 1;
        this.pdfNumPages = 0;
        switch (this.document.extension) {
          case "docx":
            await this.getWordDoc();
            break;
          case "pdf":
          case "png":
          case "jpeg":
          case "jpg":
          case "mp4":
          case "m4v":
            await this.getDocumentSrc();
            break;
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getDocumentSrc() {
      const response = await this.$axios.get(`/documents/${this.document.documentId}`);
      this.documentSrc = response.data.downloadUrl;
    },
    async getWordDoc() {
      const documentResponse = await this.$axios.get(`/documents/${this.document.documentId}`);
      const downloadResponse = await this.$axios.get(documentResponse.data.downloadUrl, { responseType: "blob" });

      var blob = new Blob([downloadResponse.data]);

      await docx.renderAsync(blob, document.getElementById("container"), null, {
        inWrapper: false,
      });
    },
  },
  watch: {
    document() {
      if (this.document && this.document.documentId) {
        this.getDocument();
      }
    },
  },
};
</script>

<style lang="scss">
.docx {
  height: 100%;
}
.docx-wrapper {
  background-color: white !important;
}
</style>
